<template>
    <div
        class="inline-block text-xs py-1 px-3 rounded font-medium"
        :class="badgeClasses"
    >
        {{ statusText }}
    </div>
</template>

<script setup>
import { computed } from "vue";

const props = defineProps({
    status: {
        type: String,
        required: true,
        validator: (value) =>
            ["pendiente", "en_proceso", "completado"].includes(value),
    },
});

const statusText = computed(() => {
    const statusMap = {
        pendiente: "Pendiente",
        en_proceso: "En Proceso",
        completado: "Completado",
    };
    return statusMap[props.status] || props.status;
});

const badgeClasses = computed(() => {
    const classMap = {
        pendiente: "bg-yellow-200 text-yellow-800",
        en_proceso: "bg-blue-200 text-blue-800",
        completado: "bg-green-200 text-green-800",
    };
    return classMap[props.status] || "bg-gray-100 text-gray-800";
});
</script>
